import * as React from "react";
import AnimatedImageHolderComponent, { AnimatedImageHolderComponentProps } from "./AnimatedImageHolderComponent";
import { SubHeaderClickHandler } from "./SubHeaderMenu";
import FlexHeader from "./FlexHeader";

import { getTaxonomyItems, getShopsList, mapShopsTaxonomyResponseToClickHandler } from "../../helpers/helpers";
import { SFTaxonomyResponse } from "../../models/sftaxonomy";
import { ShopsData } from "../../models/shops";

export interface T4ShopsProps {
    preOrPostSecurity: string;
    isSpanish: boolean;
}

export interface T4ShopsState {
    items: SubHeaderClickHandler[];
    preComps: [];
    postComps: [];
    filter: string;
}

export class T4ShopsComponent extends React.Component<T4ShopsProps, T4ShopsState> {
    state: T4ShopsState = {
        items: [],
        preComps: [],
        postComps: [],
        filter: '',
    };
    cancelled: boolean = false;

    componentWillUnmount = () => {
        this.cancelled = true;
    };

    componentDidMount = async () => {
        let sp = new URLSearchParams(window.location.search);

        let itemsPromise: Promise<SubHeaderClickHandler[]> = getTaxonomyItems(ShopsData.T4.post.taxonomyID, this.props.isSpanish)
            .then((jsonResponse: SFTaxonomyResponse) => jsonResponse.value.map((v, idx) => mapShopsTaxonomyResponseToClickHandler(v, idx, () => {
                let spp = new URLSearchParams(window.location.search);
                spp.set('gate', v.Title.replace("Gates ", ""));
                window.history.replaceState({}, '', `${window.location.pathname}?${spp}`);
                this.setState(Object.assign(this.state, { filter: v.Id }))
            })));

        let postCompsPromise = getShopsList(ShopsData.T4.post.id, this.props.isSpanish, ShopsData.T4.post.taxonomyID);

        let preCompsPromise = getShopsList(ShopsData.T4.pre.id, this.props.isSpanish);

        let postComps = await postCompsPromise;

        let preComps = await preCompsPromise;

        let items = await itemsPromise;

        const fValue = items.findIndex((i) => i.text.replace("Gates ","") === sp.get("gate"))

        if (!this.cancelled)
            this.setState(Object.assign(this.state, {
                items,
                preComps,
                postComps,
                filter: fValue === -1 ? items[0].id : items[fValue].id
            }))
    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div>
                {
                    this.props.preOrPostSecurity === 'Post-Security' ?
                        <div className="row my-2" style={{ paddingLeft: '0.5em', paddingRight: '0.5em' }}>
                            <FlexHeader activeID={this.state.filter} items={this.state.items.map((item) => item)}
                                width={"100%"} />

                        </div>
                        : null
                }
                < div className="col-12  px-0" >
                    <div className={"row"} style={{ minHeight: '500px' }}>

                        {(this.props.preOrPostSecurity === 'Post-Security' ? this.state.postComps.filter(((value: AnimatedImageHolderComponentProps) => value.category === this.state.filter)) : this.state.preComps).map((item: AnimatedImageHolderComponentProps, key) =>
                            <AnimatedImageHolderComponent
                                key={key}
                                title={item.title}
                                description={item.description}
                                imageUrl={item.imageUrl}
                                category={item.category}
                                menuUrl={item.menuUrl}
                                tags={item.tags}
                                tagsOfInterest={item.tagsOfInterest}
                                subHeading={this.props.preOrPostSecurity} />)}
                    </div>
                </div >
            </div >
        );
    }
}